<template>
  <div class="login-wrapper">
    <div class="login">
      <h1>Log in to LuxTag</h1>
          <el-form status-icon :model="ruleFormCred" :rules="rulesCred" ref="ruleFormCred" label-width="120px" label-position="top">

            <!-- old email input -->
            <!-- <el-form-item label="E-mail"  >
              <el-select v-model="ruleFormCred.accountIndex" placeholder="Select your local account">
                <el-option v-for="(account, index) in accounts" :key="index" :label="account.name" :value="index">
                </el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="E-mail" prop="email">
              <el-input type="email" v-model="ruleFormCred.email" auto-complete="off" />
            </el-form-item>

            <el-form-item label="Password" prop="pass">
              <el-input :type="inputypePrng" @keyup.enter="submitForm('ruleFormCred')" v-model="ruleFormCred.pass" auto-complete="off">
                <el-button class="btn-eye" slot="append" @click="showpassPrng">
                  <div :style="{ color: icolorPrng }">
                    <eye-off-icon v-if="inputypePrng === 'password'"  width=16></eye-off-icon>
                    <eye-icon v-if="inputypePrng === 'text'" width=16></eye-icon>
                  </div>
                </el-button>
              </el-input>
            </el-form-item>

            <el-form-item style="margin-top: 40px;">
              <el-button class="el-button-login" type="primary" @click="submitForm('ruleFormCred')" :loading="isLoginButtonLoading">Log In</el-button>
              <span class="forget-password"> Forgot your password?
                <el-button type="text" @click="toForgotPassword">Reset it.</el-button>
              </span>
            </el-form-item>
          </el-form>
      <p> Don’t have an account? <el-button type="text" @click="toSignUp">Create a LuxTag account.</el-button> </p>
    </div>
  </div>
</template>

<script>
import { EyeOffIcon, EyeIcon } from 'vue-feather-icons';
import EventBus from '../Buss/EventBus';
import luxtagApi from '../API/index';
import nem from '../../static/js/index';

export default {
  data() {
    const checkEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input your Email'));
      } else {
        // eslint-disable-next-line
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(value)) {
          callback(new Error('Please input correct email address'));
        }
      }
      callback();
    };
    return {
      activeName: 'cred',
      inputypePrng: 'password',
      iconPrng: 'eye-slash',
      icolorPrng: '#13CE66',
      accountIndex: null,
      isLoginButtonLoading: false,
      ruleFormCred: {
        email: '',
        pass: '',
      },
      rulesCred: {
        email: [
          { required: true, validator: checkEmail, trigger: 'blur' },
        ],
        pass: [
          { required: true, message: 'Please input your wallet password', trigger: 'blur' },
          { min: 6, message: 'The password should be at least 6 charachters', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    accounts() {
      return this.$store.getters.getAccounts;
    },
  },
  methods: {
    toSignUp() {
      this.$router.push('sign-up');
    },
    toForgotPassword() {
      this.$router.push('forgot');
    },
    handleClick(tab, event) {
      this.activeName = tab.name;
    },
    showpassPrng: function () {
      if (this.inputypePrng === 'password') {
        this.inputypePrng = 'text';
        this.iconPrng = 'eye';
        this.icolorPrng = '#FF4949';
      } else if (this.inputypePrng === 'text') {
        this.inputypePrng = 'password';
        this.iconPrng = 'eye-slash';
        this.icolorPrng = '#13CE66';
      }
    },
    submitForm(formName) {
      this.isLoginButtonLoading = true;
      const that = this;
      // Create a common object
      /* eslint prefer-const: 'off', no-var: 'off' */
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // request auth using password and email
          luxtagApi.auth.emailPw(that.ruleFormCred.email, that.ruleFormCred.pass)
          .then((response) => {
            // login success
            // check if there is any wallet for this account
            console.log(response);
            for (let i = 0, iLen = that.accounts.length; i < iLen; i += 1) {
              if (that.accounts[i].name === this.ruleFormCred.email) {
                that.accountIndex = i;
                break;
              }
            }

            // get wallet to decrypt
            let wallet = null;
            // if (that.accountIndex !== null) {
            //   // wallet exist on local storage for this account
            //   wallet = that.accounts[that.accountIndex].accounts[0];
            // } else {
            //   // there is no wallet in local storage for this account
            //   // create new wallet
            //   wallet = nem.model.wallet
            //   .importPrivateKey(
            //     that.ruleFormCred.email,
            //     response.data.user.passphrase,
            //     nem.crypto.helpers.derivePassSha(response.data.user.passphrase, 6000).priv,
            //     nem.model.network.data.mainnet.id);

            //   // that.$store.commit('PUSH_WALLET', wallet); // commit the wallet to the store

            //   // commit the wallet to the localStorage
            //   that.$store.dispatch('storeAccount', wallet);

            //   // get the index from the new wallet
            //   that.accountIndex = that.$store.getters.getAccounts.length - 1;

            //   // choose the first account of wallet
            //   wallet = wallet.accounts[0];
            // }

            // wallet = nem.model.wallet
            //   .importPrivateKey(
            //     that.ruleFormCred.email,
            //     response.data.user.passphrase,
            //     nem.crypto.helpers.derivePassSha(response.data.user.passphrase, 6000).priv,
            //     nem.model.network.data.mainnet.id);

            // that.$store.commit('PUSH_WALLET', wallet); // commit the wallet to the store

            // commit the wallet to the localStorage
            that.$store.dispatch('storeAccount', response.data.user.wallet);

            // get the index from the new wallet
            that.accountIndex = that.$store.getters.getAccounts.length - 1;
            // choose the first account of wallet
            wallet = response.data.user.wallet.accounts[0];

            let common = nem.model.objects.create('common')(that.ruleFormCred.pass, '');
            // https://github.com/QuantumMechanics/NEM-sdk/blob/master/src/crypto/cryptoHelpers.js#L67
            nem.crypto.helpers.passwordToPrivatekey(common, wallet, wallet.algo);
            // The common object now has a private key
            // https://github.com/QuantumMechanics/NEM-sdk/blob/master/src/crypto/cryptoHelpers.js#L130
            try {
              if (nem.crypto.helpers.checkAddress(common.privateKey,
              wallet.network,
              wallet.address)) {
                // correct pass
                EventBus.$emit('loading-start');
                // we commit name and pass to the store
                this.$store.commit('PUSH_WALLETNAME',
                that.accounts[that.accountIndex].name);
                const keyPair = nem.crypto.keyPair.create(common.privateKey);
                this.$store.commit('PUSH_PP', keyPair.publicKey.toString());
                this.$store.commit('PUSH_WALLET', wallet); // commit the wallet to the store
                this.$store.commit('PUSH_INDEX', that.accountIndex);
                this.$store.commit('PUSH_ADDRESS', wallet.address);
                this.$store.commit('PUSH_TOKEN', response.data.jwt);
                EventBus.$emit('login', {
                  login: true,
                  index: that.$store.getters.getCurrentIndex,
                  PP: that.$store.getters.getPP,
                  email: response.data.user.email,
                  token: response.data.jwt,
                  avatar: response.data.user.picture,
                  authID: response.data.user.id,
                });
                this.$router.replace('dashboard');
              } else {
                that.$message.error({
                  showClose: true,
                  message: 'Wrong Password!',
                });
              }
            } catch (e) {
              that.isLoginButtonLoading = false;
              that.$message.error({
                showClose: true,
                message: 'Wrong Password!',
              });
            }
          }).catch((error) => {
            // error callback
            console.log(error);
            that.isLoginButtonLoading = false;
            let errorMessage = '';
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              if (error.response.status === 401) {
                errorMessage = 'There was an error with your E-Mail/Password combination. Please try again';
              } else if (error.response.data.length > 0) {
                errorMessage = error.response.data;
              } else {
                errorMessage = 'There was an error';
              }
            } else if (error.request) {
              errorMessage = 'Please check your connection'; // status 0
            } else {
              // Something happened in setting up the request that triggered an Error
              errorMessage = error.message;
            }

            that.$message.error({
              showClose: true,
              message: errorMessage,
            });
          });
        } else {
          that.isLoginButtonLoading = false;
          that.$message.error({
            showClose: true,
            message: 'Invalid Form!',
          });
        }
      });
    },
  },
  components: {
    EyeOffIcon,
    EyeIcon,
  },
};
</script>



<style>
h1 {
  color: #fff;
}

.login-wrapper {
  max-width: 540px;
  color: #fff;
  width: 100%;
}

.login {
  display: block;
  text-align: left;
}

@media only screen and (min-width: 900px) {
  .login-wrapper {
      max-width: 1300px;
  }
  .login {
    display: block;
    max-width: 585px;
    margin: 0 auto;
    position: relative;
  }
}

@media screen and (max-width: 425px) {
  h1 {
    font-size: 1.8em
  }
  .login {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  p {
    text-align: center;
  }
}

span.forget-password {
  margin-left: .5em;
}

.btn-eye {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
}

.el-select {
  width: 100%;
}

.el-form--label-top .el-form-item__label {
  padding: 0px;
  color: #fff;
}

.el-form-item {
  margin-bottom: 1.13em;
}
.el-button {
  color: #a5c4ff;
}
.el-button:hover {
  color: #41A3F7;
}
.el-button-login {
  color: #fff;
  background-color: #41A3F7;
  border-color: #41A3F7;
}
.el-button-login:hover {
  color: rgb(241, 209, 209);
  background-color: #41A3F7;
  border-color: #41A3F7;
}
/* .el-form-item.is-required .el-form-item__label:before {
    display: none;
} */

input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #fff inset;
}

</style>

<style scoped>
  form {
    max-width: 400px;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?54350aad